/**
 * 작성자 : 한영광
 * 날짜 : 2023.06.26
 * 경로 : 출역 관리 - 월 출역현황
 */
import { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import { ITabObject } from 'customTypes';
import { IUser, pageInfoState, userState } from '../../atoms';
import Tab from '../../components/Tab';
import { logPost } from '../../services/log';
import Visit from './attend9/visit';
import VisitEdu from './attend9/visitEdu';
import { apiGet } from '../../services/_common';
import { useQuery } from '@tanstack/react-query';

const Sattend9 = () => {
  const size = useOutletContext<any>();
  const tabInfo = useRecoilValue(pageInfoState);
  const [currentTabMrCd, setCurrentTabMrCd] = useState(tabInfo.defaultMrCd);
  const userInfo = useRecoilValue<IUser>(userState);
  const { userMenuList } = userInfo;
  const [newTabList, setNewTabList] = useState<ITabObject[]>();
  const { data, isError } = useQuery(['edutermSetting'], () => getVisitSettingAPI(), { enabled: !!userInfo.hCd && !!userInfo.sCd });

  useEffect(() => {
    const arr: any[] = [];
    userMenuList.map((v: any) => {
      const result = tabInfo?.tabList?.find((el: ITabObject) => el.mtCd === v.mtCd && el.mdCd === v.mdCd && el.mrCd === v.mrCd);
      if (result) {
        arr.push(result);
        setNewTabList(arr);
      }
    });
  }, [tabInfo.tabList]);

  const onClickTab = (tab: string) => {
    setCurrentTabMrCd(tab);
  };

  const getVisitSettingAPI = async () => {
    const { hCd, sCd } = userInfo;
    try {
      const res = await apiGet({ path: '/visit/setting', contentType: 'application/json', req: { hCd, sCd } });
      return res.data.data;
    } catch (err) {
      console.error('err : ', err);
      throw new Error('Error');
    }
  };

  const renderPage = () => {
    const activeTab = newTabList?.find((el: ITabObject) => el.mrCd === currentTabMrCd);
    if (activeTab !== undefined) {
      const { mrCd } = activeTab;
      switch (mrCd) {
        case '001':
          return <Visit showPhoto={data?.photoYn === 'Y'} showCarnum={data?.carnumYn === 'Y'} visitHnumYn={data?.visitHnumYn === 'Y'} visitBdateYn={data?.visitBdateYn === 'Y'} />;
        case '002':
          return <VisitEdu />;
      }
    }
    return undefined;
  };

  return (
    <div className='contents'>
      <div className='content-container oneColumn'>
        <Tab tabList={newTabList || tabInfo.tabList} currentTabMrCd={currentTabMrCd} setCurrentTabMrCd={setCurrentTabMrCd} onClickTab={onClickTab} size={size} />
        {renderPage()}
      </div>
    </div>
  );
};

export default Sattend9;
